export interface UserPermission {
  email: string;
  userPermissions: ConfigurationModulePermission[];
}

export interface ConfigurationModulePermission {
    configurationID: number;
    moduleID: number;
    accessLevel: AccessLevel;
}

export enum AccessLevel {
    Read = 'Read',
    ReadWrite = 'ReadWrite'
}

export enum ConfigurationsEnum {
    SharedConfigurations = 1,
    StateConfigurations = 2,
    PharmacyConfigurations = 3,
    AdminSettings = 4
}

export const ConfigurationLabels: Record<ConfigurationsEnum, string> = {
    [ConfigurationsEnum.SharedConfigurations]: 'Shared Configurations',
    [ConfigurationsEnum.StateConfigurations]: 'State Configurations',
    [ConfigurationsEnum.PharmacyConfigurations]: 'Pharmacy Configurations',
    [ConfigurationsEnum.AdminSettings]: 'Admin Settings'
}

export const ConfigurationModuleLabels:
    Record<
        ConfigurationsEnum,
        Record<number, string>
    > =
{
    [ConfigurationsEnum.SharedConfigurations]: {
        1: 'Control Submission History',
        2: 'EPrescription Partner Settings WENO',
        3: 'EPrescription Partner Settings PC',
        4: 'EPrescription Partner Settings',
        5: 'EPrescription Partner Settings SS',
        6: 'Hyphen Configuration',
        8: 'Shared Claim Transmission',
        9: 'Shared Misc Settings',
        10: 'Escript API Settings',
        11: 'Data Entry Agent Settings'
    },
    [ConfigurationsEnum.StateConfigurations]: {
        1: 'Control Submission History'
    },
    [ConfigurationsEnum.PharmacyConfigurations]: {
        1: 'Control Submission History',
        2: 'EPrescription Partner Settings WENO',
        4: 'EPrescription Partner Settings',
        5: 'EPrescription Partner Settings SS',
        6: 'Cloud Misc Pharmacy Settings'
    },
    [ConfigurationsEnum.AdminSettings]: {
        1: 'User Management'
    },
};